import ownerDocument from './owner-document.esm.js';

function ownerWindow(node) {
  var doc = node ? ownerDocument(node) : undefined;
  return doc && doc.defaultView || window;
}

export default ownerWindow;
//# sourceMappingURL=owner-window.esm.js.map
